import React, { useEffect } from "react";
import TitleBar from "../../common/title-bar/title-bar";
import Table from "../../common/table";
import moment from "moment";
import StatusByProduct from "../../common/status-by-product";
import TableLink from "../../common/table/table-link";
import Tags from "../../common/tags";
import APIService from "../../Service/APIService.js";
import { message } from "antd";
import { useAuth } from "../AuthProvider";
import { useNavigate } from "react-router-dom";
import {
  canViewIvrDashboard,
  getDefaultHomePath,
} from "../Utils/accessControl";


const IVRDashboard = () => {
  const [ivrData, setIVRData] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const { user, isReady } = useAuth();
  const navigate = useNavigate();
  const canViewDashboard = canViewIvrDashboard(user);
  const ivrColDefs = [
    {
      headerName: "Request ID",
      field: "RequestID",
      filter: true,
      cellRenderer: (params) => {
        const pendingCount =
          params.data.ProductsByStatus?.find((item) => item.status === "pending")
            ?.count ?? 0;
        return (
          <div style={{ display: "flex", gap: "4px", alignItems: "center" }}>
            <TableLink
              value={params.data.RequestID}
              path={`/IVRDetails/${params.data.RequestID}`}
              state={{ patientID: params.data.PatientID }}
            />

            {params.data.TotalNumberOfProducts === pendingCount && (
              <Tags
                textColor="primaryColor"
                tagBackground="blueBackground"
                tagText="New"
              />
            )}
          </div>
        );
      },
    },
    {
      headerName: "Patient ID",
      field: "PatientID",
      filter: true,
    },
    {
      headerName: "Submission Date",
      field: "SubmissionDate",
      filter: true,
      cellRenderer: (params) =>
        moment(params.data.SubmissionDate).format("MM-DD-YYYY"),
    },
    {
      headerName: "Account",
      field: "AccountName",
      filter: true,
    },
    {
      headerName: "Primary Insurance",
      field: "PrimaryInsuranceName",
      filter: true,
      cellRenderer: (params) => params.data?.PrimaryInsuranceName || "N/A",
    },
    {
      headerName: "Secondary Insurance",
      field: "SecondaryInsuranceName",
      filter: true,
      cellRenderer: (params) => params.data?.SecondaryInsuranceName || "N/A",
    },
    {
      headerName: "Products By Status",
      // field: "",
      filter: true,
      cellRenderer: (params) => (
        <StatusByProduct
          status={params.data.ProductsByStatus}
          productList={params.data.productList}
          products={params.data.Products}
        />
      ),
    },
    // {
    //   headerName: "Options",
    //   field: "",
    //   cellRenderer: (params) => (
    //     <TableOptionsCell
    //       optionOne="View"
    //       optionOneType="primary"
    //       // optionOneClickPath={`/IVRProduct/${patientID}`}
    //       optionTwo="Quick Order"
    //       optionTwoType="success"
    //       optionTwoClickFn={() => {}}
    //       rowData={params.data}
    //     />
    //   ),
    // },
  ];

  useEffect(() => {
    if (!isReady) return undefined;

    if (!canViewDashboard) {
      navigate(getDefaultHomePath(user), { replace: true });
      return undefined;
    }

    let isActive = true;

    const getNewIVRs = async () => {
      setLoading(true);
      try {
        const serv = new APIService();
        const resp = await serv.getDataFromBackend("/ivr/getivrrequests");
        const data = resp?.data?.data ?? [];
        const rows = Array.isArray(data) ? data : [];

        if (isActive) {
          setIVRData(rows);
        }
      } catch (error) {
        console.error("Failed to load IVR requests:", error);
        if (isActive) {
          setIVRData([]);
          message.error("Failed to load IVR requests.");
        }
      } finally {
        if (isActive) {
          setLoading(false);
        }
      }
    };
    
    getNewIVRs();

    return () => {
      isActive = false;
    };
  }, [canViewDashboard, isReady, navigate, user]);

  if (!isReady || !canViewDashboard) {
    return null;
  }

  return (
    <div className="global-parent-container-wrapper">
      <TitleBar
        label="IVR Requests"
        invoiceNumber={`${ivrData?.length ?? 0}`}
      />
      <Table rowData={ivrData} columnDefs={ivrColDefs} loading={loading} />
    </div>
  );
};

export default IVRDashboard;
